<mat-card>
    <mat-card-header>
      <mat-card-title>Health and Character Details</mat-card-title>
    </mat-card-header>
<mat-card-content class="m-t-1">
<div class="health-container">
        <app-radio-input [label]="'Does anyone included in the application have any health conditions?'"
        [control]="healthCharacterForm.controls.anyHealthConditions" shortLabel="Health Conditions"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
        [submitAttempted]="nextClicked">
      </app-radio-input>

    @if(healthCharacterForm.controls.anyHealthConditions.value === 'true') {

     <div class="section-label">
          <mat-label>Please specify the person(s) and the health condition</mat-label>
    </div>
@if(safeHealthConditionList.length > 0) {

  @if(!(isMobile$ | async)) { 
 <table mat-table [dataSource]="safeHealthConditionList" class="mat-elevation-z1">
    
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef style="width: 28%;">Name</th>
      <td mat-cell *matCellDef="let healthCondition">{{healthCondition.person.firstName}} {{healthCondition.person.surname}}</td>
    </ng-container>

    <!-- Condition Column -->
    <ng-container matColumnDef="condition">
      <th mat-header-cell *matHeaderCellDef style="width: 14%;">Condition</th>
      <td mat-cell *matCellDef="let healthCondition">{{healthCondition.condition}}</td>
    </ng-container>

    <!-- Edit Column -->
    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef style="width: 5%;">Edit</th>
      <td mat-cell *matCellDef="let healthCondition; let i = index">
        <button mat-icon-button (click)="editHealthCondition(i)" aria-label="Edit">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Delete Column -->
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef style="width: 5%;">Delete</th>
      <td mat-cell *matCellDef="let healthCondition; let i = index">
        <button mat-icon-button (click)="removeHealthCondition(i)" aria-label="Delete" color="warn">
          <mat-icon>close</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsHealth"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsHealth;"></tr>
  </table>
}
@if(isMobile$ | async) {
        <div class="mobile-cards">
        @for(healthCondition of safeHealthConditionList; track healthCondition; let i = $index) {
        <mat-card  class="mobile-card">
          <mat-card-content>
            <div class="mobile-card-details">
              <div class="mobile-card-item">
                <span class="label">Name:</span>
                <span class="value">{{healthCondition.person.firstName}} {{healthCondition.person.surname}}</span>
              </div>
              <div class="mobile-card-item">
                <span class="label">Condition:</span>
                <span class="value">{{healthCondition.condition}}</span>
              </div>
            
            </div>
            <div class="mobile-card-actions">
              <button mat-stroked-button (click)="editHealthCondition(i)" class="action-button">
                <mat-icon>edit</mat-icon>
                Edit
              </button>
              <button mat-stroked-button color="warn" (click)="removeHealthCondition(i)" class="action-button">
                <mat-icon>delete</mat-icon>
                Delete
              </button>
            </div>
          </mat-card-content>
        </mat-card>
  
      }
    </div>
}

  }
   <button mat-raised-button color="primary" (click)="addHealthCondition()">Add Health Condition</button>
 
}

<app-radio-input [label]="'Has anyone included in the application ever committed a criminal offence?'"
        [control]="healthCharacterForm.controls.anyCrime" shortLabel="Criminal Offence"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
        [submitAttempted]="nextClicked">
</app-radio-input>

@if(healthCharacterForm.controls.anyCrime.value === 'true') {

     <div class="section-label">
          <mat-label>Please specify the person(s) and offence(s)</mat-label>
    </div>
    @if(safeCrimeList.length > 0) {
      @if(!(isMobile$ | async)) { 
 <table mat-table [dataSource]="safeCrimeList" class="mat-elevation-z1">
    
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef style="width: 28%;">Name</th>
      <td mat-cell *matCellDef="let crimeDetails">{{crimeDetails.person.firstName}} {{crimeDetails.person.surname}}</td>
    </ng-container>

    <!-- Offence Column -->
    <ng-container matColumnDef="offence">
      <th mat-header-cell *matHeaderCellDef style="width: 14%;">Offence</th>
      <td mat-cell *matCellDef="let crimeDetails">{{crimeDetails.offence}}</td>
    </ng-container>

    <!-- Edit Column -->
    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef style="width: 5%;">Edit</th>
      <td mat-cell *matCellDef="let crimeDetails; let i = index">
        <button mat-icon-button (click)="editCrime(i)" aria-label="Edit">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Delete Column -->
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef style="width: 5%;">Delete</th>
      <td mat-cell *matCellDef="let crimeDetails; let i = index">
        <button mat-icon-button (click)="removeCrime(i)" aria-label="Delete" color="warn">
          <mat-icon>close</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsCrime"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsCrime;"></tr>
  </table>
}
@if(isMobile$ | async){
    <div class="mobile-cards">
        @for(crimeDetails of safeCrimeList; track crimeDetails; let i = $index) {
        <mat-card  class="mobile-card">
          <mat-card-content>
            <div class="mobile-card-details">
              <div class="mobile-card-item">
                <span class="label">Name:</span>
                <span class="value">{{crimeDetails.person.firstName}} {{crimeDetails.person.surname}}</span>
              </div>
              <div class="mobile-card-item">
                <span class="label">Offence:</span>
                <span class="value">{{crimeDetails.offence}}</span>
              </div>
            
            </div>
            <div class="mobile-card-actions">
              <button mat-stroked-button (click)="editCrime(i)" class="action-button">
                <mat-icon>edit</mat-icon>
                Edit
              </button>
              <button mat-stroked-button color="warn" (click)="removeCrime(i)" class="action-button">
                <mat-icon>delete</mat-icon>
                Delete
              </button>
            </div>
          </mat-card-content>
        </mat-card>
  
      }
    </div>
}
  }
   <button mat-raised-button color="primary" (click)="addCrime()">Add Crime</button>
  }
<app-radio-input [label]="'Has anyone included in this application previously been refused a visa to Australia?'"
        [control]="healthCharacterForm.controls.refusedVisa" shortLabel="Refused Visa"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
        [submitAttempted]="nextClicked">
</app-radio-input>

@if(healthCharacterForm.controls.refusedVisa.value === 'true') {
     <div class="section-label">
          <mat-label>Please specify the person(s) and reason(s) the visa was refused</mat-label>
    </div>

    @if(safeRefusedVisaList.length > 0) {

      @if(!(isMobile$ | async)) { 
    <table mat-table [dataSource]="safeRefusedVisaList" class="mat-elevation-z1">

    <!-- Name Column -->
    <ng-container matColumnDef="name">              
      <th mat-header-cell *matHeaderCellDef style="width: 28%;">Name</th>
      <td mat-cell *matCellDef="let refusedVisaDetails">{{refusedVisaDetails.person.firstName}} {{refusedVisaDetails.person.surname}}</td>
    </ng-container>

    <!-- Refused Column -->
    <ng-container matColumnDef="refused">
      <th mat-header-cell *matHeaderCellDef style="width: 14%;">Refused</th>
      <td mat-cell *matCellDef="let refusedVisaDetails">{{refusedVisaDetails.refused}}</td>
    </ng-container>

    <!-- Edit Column -->
    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef style="width: 5%;">Edit</th>  
      <td mat-cell *matCellDef="let refusedVisaDetails; let i = index">
        <button mat-icon-button (click)="editVisaRefusal(i)" aria-label="Edit">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Delete Column -->
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef style="width: 5%;">Delete</th>
      <td mat-cell *matCellDef="let refusedVisaDetails; let i = index">
        <button mat-icon-button (click)="removeVisaRefusal(i)" aria-label="Delete" color="warn">
          <mat-icon>close</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsVisa"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsVisa;"></tr>
  </table>
  }
  @if(isMobile$ | async){
        <div class="mobile-cards">
        @for(refusedVisaDetails of safeRefusedVisaList; track refusedVisaDetails; let i = $index) {
        <mat-card  class="mobile-card">
          <mat-card-content>
            <div class="mobile-card-details">
              <div class="mobile-card-item">
                <span class="label">Name:</span>
                <span class="value">{{refusedVisaDetails.person.firstName}} {{refusedVisaDetails.person.surname}}</span>
              </div>
              <div class="mobile-card-item">
                <span class="label">Refused:</span>
                <span class="value">{{refusedVisaDetails.refused}}</span>
              </div>
            
            </div>
            <div class="mobile-card-actions">
              <button mat-stroked-button (click)="editVisaRefusal(i)" class="action-button">
                <mat-icon>edit</mat-icon>
                Edit
              </button>
              <button mat-stroked-button color="warn" (click)="removeVisaRefusal(i)" class="action-button">
                <mat-icon>delete</mat-icon>
                Delete
              </button>
            </div>
          </mat-card-content>
        </mat-card>
  
      }
    </div>
  }
  }
   <button mat-raised-button color="primary" (click)="addVisaRefusal()">Add Visa Refusal</button>
  }

<app-radio-input [label]="'Has anyone included in this application previously had an Australian visa cancelled?'"
        [control]="healthCharacterForm.controls.cancelledVisa" shortLabel="Cancelled Visa"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
        [submitAttempted]="nextClicked">
</app-radio-input>

@if(healthCharacterForm.controls.cancelledVisa.value === 'true') {
     <div class="section-label">
          <mat-label>Please specify the person(s) and reason(s) the visa was cancelled</mat-label>
    </div>

    @if(safeCancelledVisaList.length > 0) {
      @if(!(isMobile$ | async)) { 
     <table mat-table [dataSource]="safeCancelledVisaList" class="mat-elevation-z1">

    <!-- Name Column -->
    <ng-container matColumnDef="name">              
      <th mat-header-cell *matHeaderCellDef style="width: 28%;">Name</th>
      <td mat-cell *matCellDef="let cancelledVisaDetails">{{cancelledVisaDetails.person.firstName}} {{cancelledVisaDetails.person.surname}}</td>
    </ng-container>

    <!-- Cancelled Column -->
    <ng-container matColumnDef="cancelled">
      <th mat-header-cell *matHeaderCellDef style="width: 14%;">Cancelled</th>
      <td mat-cell *matCellDef="let cancelledVisaDetails">{{cancelledVisaDetails.cancelled}}</td>
    </ng-container>

    <!-- Edit Column -->
    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef style="width: 5%;">Edit</th>  
      <td mat-cell *matCellDef="let cancelledVisaDetails; let i = index">
        <button mat-icon-button (click)="editVisaCancellation(i)" aria-label="Edit">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Delete Column -->
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef style="width: 5%;">Delete</th>
      <td mat-cell *matCellDef="let cancelledVisaDetails; let i = index">
        <button mat-icon-button (click)="removeVisaCancellation(i)" aria-label="Delete" color="warn">
          <mat-icon>close</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsCancelledVisa"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsCancelledVisa;"></tr>
  </table>
}
@if(isMobile$ | async){
          <div class="mobile-cards">
        @for(cancelledVisaDetails of safeCancelledVisaList; track cancelledVisaDetails; let i = $index) {
        <mat-card  class="mobile-card">
          <mat-card-content>
            <div class="mobile-card-details">
              <div class="mobile-card-item">
                <span class="label">Name:</span>
                <span class="value">{{cancelledVisaDetails.person.firstName}} {{cancelledVisaDetails.person.surname}}</span>
              </div>
              <div class="mobile-card-item">
                <span class="label">Cancelled:</span>
                <span class="value">{{cancelledVisaDetails.cancelled}}</span>
              </div>
            
            </div>
            <div class="mobile-card-actions">
              <button mat-stroked-button (click)="editVisaCancellation(i)" class="action-button">
                <mat-icon>edit</mat-icon>
                Edit
              </button>
              <button mat-stroked-button color="warn" (click)="removeVisaCancellation(i)" class="action-button">
                <mat-icon>delete</mat-icon>
                Delete
              </button>
            </div>
          </mat-card-content>
        </mat-card>
  
      }
    </div>
}
  }
  <button mat-raised-button color="primary" (click)="addVisaCancellation()">Add Visa Cancellation</button>
}

</div>

</mat-card-content>
